import React, { useEffect, useState } from "react";
import { useLoginFakeMutation } from "src/services";
import { useNavigate } from "react-router-dom";
import { Flex } from "@nubeteck/components";
import { Content } from "antd/es/layout/layout";
import { LargeHeadingStyled, SectionHeaderStyled } from "src/components/custom/texts/texts.styled";
import { Button, Form, Input, Skeleton } from "antd";
import { useErrorStudentIdRequiredToast } from "src/constants";
import { getEnterStudentPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";

const FakeLogin = () => {
  const [form] = Form.useForm<any>();
  const { validateFields } = form;
  const [loginFake, { data, isSuccess, isLoading }] = useLoginFakeMutation();
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const navigate = useNavigate();
  const showErrorStudentIdRequiredToast = useErrorStudentIdRequiredToast();
  const { locale } = useLocale();
  const [enterStudentPage, setEnterStudentPage] = useState<any>(null);

  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("refreshToken", JSON.stringify(data.data.refreshToken));
      navigate("/");
      window.location.reload();
    }
  }, [data, isSuccess, navigate]);

  const submit = () => {
    validateFields(["matricula"])
      .then((values) => {
        if (values) {
          loginFake(values);
        }
      })
      .catch(() => {
        showErrorStudentIdRequiredToast();
      });
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setEnterStudentPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    getEnterStudentPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnterStudentPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnterStudentPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setEnterStudentPage(null);
      }}
    />;
  }

  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      <Content style={{ marginTop: "16px" }}>
        <SectionHeaderStyled>
          <LargeHeadingStyled>
            {isLoadingContent ? (
              <Skeleton.Input active size="large" style={{ width: 300 }} />
            ) : (
              enterStudentPage?.title || "Ingresar como usuario estudiante"
            )}
          </LargeHeadingStyled>
        </SectionHeaderStyled>
        <Flex style={{ gap: "15px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={submit}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
            initialValues={{
              id: 1,
            }}
          >
            <Form.Item
              name="matricula"
              label={
                isLoadingContent ? (
                  <Skeleton.Input active size="default" style={{ width: 200 }} />
                ) : (
                  enterStudentPage?.requered || "ID del estudiante"
                )
              }
              hasFeedback
              rules={[
                {
                  required: true,
                  message: enterStudentPage?.required_message || "Este campo es requerido",
                },
              ]}
            >
              <Input disabled={isLoadingContent} />
            </Form.Item>

            <Button 
              type="primary" 
              size="large" 
              htmlType="submit" 
              loading={isLoading || isLoadingContent}
              disabled={isLoadingContent}
            >
              {isLoadingContent ? (
                <Skeleton.Input active size="default" style={{ width: 100 }} />
              ) : (
                enterStudentPage?.enter_button || "Ingresar"
              )}
            </Button>
          </Form>
        </Flex>
      </Content>
    </Flex>
  );
};

export default FakeLogin;
